module.exports = __webpack_public_path__ + "static/media/180.8f57ae30.webp";